<template>
  <v-card
    @click="$emit('click')"
    class="client feedback-card"
    style="cursor: pointer;"
    tile
    flat
  >
    <v-layout align-start justify-start row fill-height class="py-3">
      <v-flex xs2 class="text-xs-center">
        <v-layout align-center justify-start row fill-height class="pl-2">
          <v-flex>
            <v-progress-circular
              :value="Number(application.completion)"
              :size="90"
              :width="5"
              :rotate="-90"
              :color="
                application.complete
                  ? themes.client.light.primary
                  : themes.client.light.warning
              "
            >
              <v-avatar size="80">
                <img
                  v-if="application.profile"
                  :src="
                    application.profile.avatar ||
                      '/img/missing/avatars/original.png'
                  "
                  v-img-orientation-changer
                />
              </v-avatar>
              <v-avatar
                v-if="featuredQualification"
                style="position: absolute; top: 45px; right: -15px;"
                size="40"
              >
                <img
                  v-if="
                    !featuredQualification.institution ||
                      !featuredQualification.institution.logo
                  "
                  src="/img/missing/logos/institutions/original.png"
                />
                <img v-else :src="featuredQualification.institution.logo" />
              </v-avatar>
            </v-progress-circular>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs8>
        <v-card-title
          primary-title
          class="py-0"
          @click="$emit('click', feedbackRequest.id)"
        >
          <div>
            <div class="headline">
              {{ application.profile.fullName }}
              <v-tooltip
                bottom
                color="grey darken-3"
                v-if="!application.complete"
              >
                <v-icon
                  slot="activator"
                  class="text-vertical-middle"
                  color="warning"
                >
                  mdi-account
                </v-icon>
                <span>Incomplete Application</span>
              </v-tooltip>
              <v-tooltip
                v-if="
                  application.eligibility &&
                    application.eligibility.eligible == false
                "
                color="grey darken-3"
                bottom
              >
                <span slot="activator">
                  <v-icon class="text-vertical-middle" color="error"
                    >mdi-alert-circle</v-icon
                  >
                </span>
                <span>Ineligible</span>
              </v-tooltip>
            </div>
            <div
              v-if="featuredQualification"
              :class="themes.client.light.mutedText"
              class="caption"
            >
              {{ featuredQualification.qualificationTypeName }}
              <span v-if="featuredQualification.specialization">
                in {{ featuredQualification.specialization }}
              </span>
            </div>
            <div
              v-if="
                featuredQualification && featuredQualification.institutionName
              "
              :class="themes.client.light.mutedText"
              class="caption"
            >
              from {{ featuredQualification.institutionName }}
            </div>
            <div
              v-if="feedbackRequest.response && feedbackRequest.response.length"
              :class="{
                'fade-out-right': feedbackRequest.response.length > 50
              }"
              class="mt-2"
            >
              <v-chip>
                <v-avatar v-if="feedbackRequest.responder">
                  <img
                    :src="
                      feedbackRequest.responder.avatar ||
                        'img/missing/avatars/original.png'
                    "
                    v-img-orientation-changer
                  />
                </v-avatar>
                {{ feedbackRequest.response.substring(0, 50) }}
                {{ feedbackRequest.response.length > 50 ? "..." : "" }}
              </v-chip>
            </div>
          </div>
        </v-card-title>
      </v-flex>
      <v-flex xs3 class="text-xs-right grey--text caption mr-3">
        <v-tooltip
          :color="themes.client.light.tooltip"
          :disabled="
            application.opportunity &&
              application.opportunity.locations.length < 2
          "
          bottom
        >
          <span slot="activator">
            Applied {{ application.createdAt | inWords({ addSuffix: true }) }}
            <span
              v-if="
                application.opportunity &&
                  application.opportunity.locations.length > 1 &&
                  application.locations
              "
            >
              at {{ application.locations.length }} locations
            </span>
          </span>
          <span>
            {{ application.locations.map(l => l.address).join(",") }}
          </span>
        </v-tooltip>
        <div class="py-1">
          <FeedbackRequestsOverview
            v-if="feedbackRequest.respondedAt !== null"
            :application-id="application.id"
          />
        </div>
      </v-flex>
    </v-layout>
    <FeedbackToolbar
      v-if="feedbackRequest.isPositive === null"
      :feedbackRequest="feedbackRequest"
      color="transparent"
      on-hover
    />
  </v-card>
</template>

<script>
// Components
import ApplicationRating from "@/components/client/applications/ApplicationRating";
import FeedbackToolbar from "@/components/client/feedback_requests/FeedbackToolbar";
import FeedbackRequestsOverview from "@/components/client/feedback_requests/FeedbackRequestsOverview";

// Helpers
import _ from "lodash";

export default {
  components: { ApplicationRating, FeedbackToolbar, FeedbackRequestsOverview },

  props: { feedbackRequest: { type: Object, required: true } },

  computed: {
    application() {
      return _.get(this.feedbackRequest, "opportunityApplication");
    },

    featuredQualification() {
      if (_.get(this.application, "profile.profileQualification")) {
        // Use featured if available
        return this.application.profile.profileQualification;
      } else if (_.get(this.application, "profile.profileQualifications[0]")) {
        // Otherwise find featured in list
        const qualifications = JSON.parse(
          JSON.stringify(this.application.profile.profileQualifications)
        );
        return qualifications.filter(pq => pq.featured)[0];
      } else {
        // Otherwise show none
        return null;
      }
    }
  }
};
</script>

<style lang="scss">
.client.feedback-card {
  opacity: 0.8;

  &:hover,
  &:hover .client.feedback.toolbar .show-on-hover {
    opacity: 1;
  }

  .fade-out-right .v-chip__content {
    &::after {
      content: " ";
      position: absolute;
      top: 0;
      height: 80%;
      width: 95%;
      transform: translateY(10%);
      border-radius: 3rem;

      background: linear-gradient(to right, transparent 70%, #e0e0e0);
    }
  }
}
</style>
